import { FC } from "react"

interface ChatFiltersProps {
  onlyReported: boolean
  showDeleted: boolean
  onOnlyReportedChange: (value: boolean) => void
  onShowDeletedChange: (value: boolean) => void
  onRefresh: () => void
}

export const ChatFilters: FC<ChatFiltersProps> = ({ onlyReported, showDeleted, onOnlyReportedChange, onShowDeletedChange, onRefresh }) => {
  return (
    <div className="flex items-center space-x-3">
      <label className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 cursor-pointer">
        <input
          type="checkbox"
          checked={onlyReported}
          onChange={(e) => onOnlyReportedChange(e.target.checked)}
          className="rounded border-gray-300 dark:border-gray-600"
        />
        <span>Only reported</span>
      </label>
      <label className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 cursor-pointer">
        <input
          type="checkbox"
          checked={showDeleted}
          onChange={(e) => onShowDeletedChange(e.target.checked)}
          className="rounded border-gray-300 dark:border-gray-600"
        />
        <span>Show deleted</span>
      </label>
      <button
        onClick={onRefresh}
        className="px-3 py-1.5 text-xs border border-[rgba(139,92,246,0.8)] dark:border-[rgba(139,92,246,0.5)] rounded-lg hover:bg-[rgba(139,92,246,0.1)] text-[rgba(139,92,246,1)] dark:text-white transition-all"
      >
        Refresh
      </button>
    </div>
  )
}
